
export { Box } from "/vercel/path0/styled-system/jsx/box.mjs"
export { styled } from "/vercel/path0/styled-system/jsx/factory.mjs"